module.exports = __webpack_public_path__ + "static/prakhar-review-6b7d6f922b3a62be03b965856d7aa387.png";